import './App.css';
import MainContainer from  './MainContainer';

function App() {
  return (
    <div className="App">
      <MainContainer />
    </div>
  );
}

export default App;
